import { ModalComponent } from "../../types";

export const PaymentCtx = {
  paymentModal: null as ModalComponent | null,
};